import clientConfigManagement from './client-config-management';
import uiManagement from './ui-management';
import domainSetups from '../domain-setups';
import vueSetupManagement from './vue-setup-management';
import viewNavigationManagement from './view-navigation-management';
import userManagement from './user-management';
import lobbyHelperService from '../services/lobby-helper-service';
import popStateManagement from './pop-state-management';
import soarPayManagement from './soar-pay/soar-pay-management';
import zendeskManagement from './zendesk-management';
import maintenanceManagement from './maintenance-management';
import flutterManagement from './flutter-management';
import OptimoveManagement from './optimove-management';
import gameFilterManagement from './game-filter-management';
import realtimeBonusEngineManagement from './realtime-bonus-engine-management';
import miniGameManagement from './mini-games/mini-game-management';
import rtbeMiniGameManagement from './rtbe-minigame-management';
import bfcacheManagement from './bfcache-management';
import guestTabFreshnessManagement from './guest-tab-freshness-management';
import creditsManagement from './credits-management';
import currencyManagement from './currency-management';
import browserHistoryHelper from '../utils/browser-history-helper';
import modelUtils from '../utils/model-utils';
import model from '../model';
import type { ManagementModule, SettableModelModule } from '../types/management-types';
import premierResourcesManagement from './premier-resources-management';

const settableModelModules: SettableModelModule[] = [
    modelUtils,
    browserHistoryHelper,
    currencyManagement,
    creditsManagement,
];

const managementModules: ManagementModule[] = [
    clientConfigManagement,
    domainSetups,
    premierResourcesManagement,
    bfcacheManagement,
    guestTabFreshnessManagement,
    uiManagement,
    vueSetupManagement,
    viewNavigationManagement,
    userManagement,
    flutterManagement,
    lobbyHelperService,
    popStateManagement,
    soarPayManagement,
    zendeskManagement,
    maintenanceManagement,
    OptimoveManagement,
    gameFilterManagement,
    realtimeBonusEngineManagement,
    miniGameManagement,
    rtbeMiniGameManagement,
];

export async function initManagementModulesAndModelRefs(){
    for(const m of settableModelModules) {
        m.setModel(model);
    }

    for(const m of managementModules) {
        await m.init();
    }
}
